var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pill-badge-contextual'),_c('pill-badge-glow'),_c('pill-badge-light'),_c('pill-badge-notification'),_c('pill-badge-link-block')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }